import styled from 'styled-components';
import { Alert } from 'antd';
import ResizablePanel from '@shared/components/ResizablePanel';

export const Container = styled.div`
  position: relative;
  height: calc(100vh - 26px - 60px);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  flex: none;
  padding: 16px;
  gap: 16px;
  background: #fff;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
`;

export const ContentPanel = styled(ResizablePanel)`
  flex: auto;
  height: 1px;
`;

export const AnalysisSection = styled.div`
  padding: 12px;
  background: #fff;

  & + & {
    margin-top: 8px;
  }
`;

export const DashboardAlert = styled(Alert)`
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 50;
  transform: translate(-50%, -50%);
`;
